//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getPlatformName } from '@/lib/platforms'

export default {
  name: 'CreatePostImportsButtonDropdown',
  props: {
    includeImportOptions: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      bulkImportablePlatforms: [
        'reddit',
        'twitter',
        'instagram',
        'tiktok',
        'bluesky'
      ]
    }
  },
  methods: {
    getPlatformName
  },
  computed: {
    isConnectedToImportablePlatform() {
      return this.bulkImportablePlatforms.some((platform) =>
        this.$store.getters.isConnectedToPlatform(platform)
      )
    }
  }
}
